import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useCompany } from '@shared-admin-kit/core'

import { fetchAvailableLanguagesAction } from './actions/available-languages.action'
import { widgetModalContainerId } from './components/image-field/image-field'
import Routes from './routes'
import { updateMainClientInstanceHeaders } from './services/api/client'
import './widget.styles'

function App() {
  const { activeProjectUuid } = useCompany()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAvailableLanguagesAction())
  }, [])

  useEffect(() => {
    updateMainClientInstanceHeaders()
  }, [activeProjectUuid])

  return (
    <>
      <Routes />
      <div id={widgetModalContainerId} style={{ zIndex: 10000, position: 'relative' }} />
    </>
  )
}

export default App
